import Vue from 'vue';
import Router from 'vue-router';
//import Meta from 'vue-meta';

import Home from '@/pages/Home.vue';
import Page from '@/pages/Page.vue';
import Subpage from '@/pages/Subpage.vue';
import Diraryform from '@/pages/Diraryform.vue';

Vue.use(Router);
//Vue.use(Meta);

const router = new Router({
    mode: 'history',
    base: '/',
    routes: [
        {
            path: '/',
            name: 'home',
            component: Home
        },
        {
            path: '/:parent/:slug',
            name: 'page',
            component: Page
        },
        {
            path: '/:parent/:slug/notat',
            name: 'diraryform',
            component: Diraryform,
            props: true
        },
        {
            path: '/:parent/:slug/:subpage',
            name: 'subpage',
            component: Subpage
        },    
    ]
});

export default router;
